import { TFunction } from 'hooks/useI18n';
import { FeaturesItemTypes } from './Features.types';
import { getPublicPath } from 'utils/paths';

export const FEATURESITEMS = (t: TFunction): FeaturesItemTypes[] => [
  {
    title: t('talent-engine-landing.features.feature1-title'),
    desc: 'talent-engine-landing.features.feature1-desc',
    image: getPublicPath('/images/talentEngine/landing-feature1.jpg'),
    imageSm: getPublicPath('/images/talentEngine/landing-feature1-sm.png')
  },
  {
    title: t('talent-engine-landing.features.feature2-title'),
    desc: 'talent-engine-landing.features.feature2-desc',
    image: getPublicPath('/images/talentEngine/landing-feature2.jpg'),
    imageSm: getPublicPath('/images/talentEngine/landing-feature2-sm.png')
  },
  {
    title: t('talent-engine-landing.features.feature3-title'),
    desc: 'talent-engine-landing.features.feature3-desc',
    image: getPublicPath('/images/talentEngine/landing-feature3.jpg'),
    imageSm: getPublicPath('/images/talentEngine/landing-feature3-sm.png')
  },
  {
    title: t('talent-engine-landing.features.feature4-title'),
    desc: 'talent-engine-landing.features.feature4-desc',
    image: getPublicPath('/images/talentEngine/landing-feature4.jpg'),
    imageSm: getPublicPath('/images/talentEngine/landing-feature4.jpg')
  }
];
